import { useSharedState } from "./useSharedState";

export function useAudioContext() {
  const state = useSharedState();

  return state ? state.audioContext : undefined;
}
